/**
 * Initializes the Swym wishlist functionality.
 * Dispatches a custom event 'swat-initialized' when Swym is initialized.
 * Adds event listeners to the wishlist button to handle adding/removing products from the wishlist.
 */
function swymCallbackFn() {
    document.dispatchEvent(new CustomEvent('swat-initialized'));

    const wishlistButton = document.querySelector(".wishlist-button-product.wishlist-btn");
    if (wishlistButton) {
        const wishlistIcon = wishlistButton.querySelector('svg');
        wishlistButton.addEventListener("click", function (e) {
            if (window.SwymPageData && !window.currentProductIsWishlisted) {
                window.SwymPageData.et = 4;  // et 4 stands for wishlist event type
                _swat.addToWishList(window.SwymPageData, function (e) {
                    const wishListIconTemplate = document.querySelector('[data-wishlist-icon="full"]');
                    wishlistIcon.replaceWith(document.importNode(wishListIconTemplate.content, true));
                    wishlistButton.closest('.wishlist-btn').classList.add('wishlist-btn--active');
                    document.dispatchEvent(new CustomEvent('swat-wishlist-updated'));
                });
            } else if (window.SwymPageData && window.currentProductIsWishlisted) {
                _swat.removeFromWishList(window.SwymPageData, function (e) {
                    const wishListIconTemplate = document.querySelector('[data-wishlist-icon="empty"]');
                    wishlistIcon.replaceWith(document.importNode(wishListIconTemplate.content, true));
                    wishlistButton.closest('.wishlist-btn').classList.remove('wishlist-btn--active');
                    document.dispatchEvent(new CustomEvent('swat-wishlist-updated'));
                });
            }
            wishlistButton.blur();
        });
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

/**
 * Sets the Swym wishlist icons based on the current wishlist state.
 * Fetches the wishlist data and updates the icons accordingly.
 */
async function setSwymIcons() {
    console.log('setSwymIcons');
    if (!window._swat) return;

    let onSuccess = function (lists) {
        // The freshly fetched list is authoritative, so clear the wishlisted state from
        // every control before re-applying it below. Without this the class is add-only:
        // a product removed while the page stays open would keep .wishlist-btn--active and
        // its button would keep announcing "remove from wishlist" while actually adding.
        document.querySelectorAll('.wishlist-btn--active').forEach(btn => {
            btn.classList.remove('wishlist-btn--active');
        });

        const wishListIconTemplate = document.querySelector('[data-wishlist-icon="full"]');
        if (!lists || lists.length == 0 || !wishListIconTemplate) return;

        // Check if current product is in the wishlist
        const products = lists[0].listcontents;
        const count = products.length;
        window.currentProductIsWishlisted = products.filter(product => product.epi === window.SwymPageData.epi).length > 0;
        products.forEach(product => {
            document.querySelectorAll(`[data-wishlist-icon-id="${product.epi}"]`).forEach(el => {
                // Replace innerHtml with the template
                el.innerHTML = '';
                el.appendChild(document.importNode(wishListIconTemplate.content, true));
                el.closest('.wishlist-btn').classList.add('wishlist-btn--active');
            });
        });

        const wishlistCountSpans = document.querySelectorAll('[data-wishlist-count]');
        const iconTemplates = {
            empty: wishlistCountSpans[0].parentElement.querySelector('template[data-wishlist-icon="empty"]').content,
            full: wishlistCountSpans[0].parentElement.querySelector('template[data-wishlist-icon="full"]').content
        }

        // Swap the icon and update the count
        wishlistCountSpans.forEach((el) => { el.innerHTML = count > 9 ? count : count === 0 ? '' : count; });
    }

    let onError = function (error) {
        console.log("Error while fetching all Lists", error);
    };

    await window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
    });
}

document.addEventListener('swat-initialized', setSwymIcons);
document.addEventListener('swat-wishlist-updated', setSwymIcons);

window.theme = window.theme || {};

/**
 * Fetches the product-card of a product via the section-rendering-api and returns the HTML.
 *
 * @param {Object} product - The product object.
 * @param {String} className - The class name to add to the product card.
 * @param {String} [type='product-card'] - The type of the product card.
 * @returns {String} - The HTML of the product card.
 */
theme.renderProductCard = async (product, className, type = 'product-card') => {
    let html;
    const sectionId = type;

    await fetch(`${window.Shopify.routes.root}products/${product.handle}?sections=${sectionId}${product.variant ? '&' + product.variant : ''}`)
        .then(response => response.json())
        .then(data => {
            if (!data) return;
            const parser = new DOMParser();
            html = parser.parseFromString(data[sectionId], 'text/html').querySelector(`#shopify-section-${sectionId}`);
            if (!html) return;
            if (className) {
                if (html.querySelector('a')) {
                    html.querySelector('a').classList.add(className);
                    html.querySelector('a').href = product.url;
                }
            }
        }).catch(error => {
            console.log(error);
        });

    if (html) {
        return html.innerHTML;
    }

    return '';
}

/**
 * Removes a product from the wishlist.
 *
 * @param {Object} product - The product object to remove from the wishlist.
 */
theme.removeProductFromWishlist = (product) => {
    console.log('removeProductFromWishlist');
    document.dispatchEvent(new CustomEvent('remove-product-from-wishlist', { detail: product }));
}

/**
 * Adds a product to the wishlist.
 *
 * @param {Event} event - The event object.
 * @param {Object} product - The product object to add to the wishlist.
 */
theme.addProductToWishlist = (event, product) => {
    console.log('addProductToWishlist');
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('add-product-to-wishlist', { detail: product }));
}

document.addEventListener('add-product-to-wishlist', async event => {
    if (!window._swat) return;
    const product = event.detail;

    // Show loader before removing product from wishlist
    const handleLoading = (product) => {
        const wishListIconTemplateLoading = document.querySelector('[data-wishlist-icon="loading"]');
        document.querySelectorAll(`[data-wishlist-icon-id="${product.epi}"]`).forEach(el => {
            el.innerHTML = '';
            el.appendChild(document.importNode(wishListIconTemplateLoading.content, true));
        });
    }

    handleLoading(product);

    let onSuccess = function (lists) {
        // Check if current product is in the wishlist
        const products = lists && lists.length > 0 ? lists[0].listcontents : [];
        const isWishlisted = products.filter(p => p.epi === product.epi).length > 0;
        if (!isWishlisted) {
            window._swat.addToWishList(product, () => {
                document.dispatchEvent(new CustomEvent('swat-wishlist-updated'));
            });
        } else {
            window._swat.removeFromWishList(product, () => {
                const wishListIconTemplateEmpty = document.querySelector('[data-wishlist-icon="empty"]');
                document.querySelectorAll(`[data-wishlist-icon-id="${product.epi}"]`).forEach(el => {
                    el.innerHTML = '';
                    el.appendChild(document.importNode(wishListIconTemplateEmpty.content, true));
                });
                document.dispatchEvent(new CustomEvent('swat-wishlist-updated'));
            });
        }
    }

    let onError = function (error) {
        console.log("Error while fetching all Lists", error);
    };

    await window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
    });
});

/**
 * Adds a cart item to the wishlist.
 *
 * @param {Event} event - The event object.
 * @param {Object} product - The product object to add to the wishlist.
 */
theme.addCartItemToWishlist = (event, product) => {
    if (!window._swat) return;

    // Show loader before removing product from wishlist
    const handleLoading = (product) => {
        const wishListIconTemplateLoading = document.querySelector('[data-wishlist-icon="loading"]');
        document.querySelectorAll(`.cart-item__wishlist[data-variant-id="${product.epi}"]`).forEach(el => {
            el.innerHTML = '';
            el.appendChild(document.importNode(wishListIconTemplateLoading.content, true));
        });
    }

    handleLoading(product);

    let onSuccess = function (lists) {
        // Check if current product is in the wishlist
        const products = lists && lists.length > 0 ? lists[0].listcontents : [];
        const isWishlisted = products.filter(p => p.epi === product.epi).length > 0;
        if (!isWishlisted) {
            window._swat.addToWishList(product, () => {
                document.dispatchEvent(new CustomEvent('swat-wishlist-updated'));
                //update PDP ATC
                let productBtnIcon = document.querySelector('.wishlist-button-product div[data-wishlist-icon-id="'+product.epi+'"]');
                if(productBtnIcon && !productBtnIcon.parentElement.classList.contains('wishlist-btn--active')){
                    productBtnIcon.parentElement.classList.add('wishlist-btn--active');
                }
            });
            event.target.innerText = event.target.dataset.textRemove;

        } else {
            window._swat.removeFromWishList(product, () => {
                event.target.innerText = event.target.dataset.textAdd;
                document.dispatchEvent(new CustomEvent('swat-wishlist-updated'));
                //update PDP ATC
                let productBtnIcon = document.querySelector('.wishlist-button-product div[data-wishlist-icon-id="'+product.epi+'"]');
                if(productBtnIcon && productBtnIcon.parentElement.classList.contains('wishlist-btn--active')){
                    productBtnIcon.parentElement.classList.remove('wishlist-btn--active');
                }
            });
        }
    }

    let onError = function (error) {
        console.log("Error while fetching all Lists", error);
    };

    window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
    });
};

/**
 * Handles the wishlist buttons in the cart.
 * Updates the wishlist buttons based on the current wishlist state.
 */
function handleCartWishlistButtons() {
    if (!window._swat) return;

    let onSuccess = function (lists) {
        const wishListIconTemplate = document.querySelector('[data-wishlist-icon="full"]');
        if (!lists || lists.length == 0 || !wishListIconTemplate) return;

        // Check if current product is in the wishlist
        const products = lists[0].listcontents;

        // window.currentProductIsWishlisted = products.filter(product => product.epi === window.SwymPageData.epi).length > 0;
        products.forEach(product => {
            document.querySelectorAll(`.cart-item__wishlist[data-variant-id="${product.epi}"]`).forEach(el => {
                el.innerText = el.dataset.textRemove;
                //update PDP ATC
                let productBtnIcon = document.querySelector('.wishlist-button-product div[data-wishlist-icon-id="'+product.epi+'"]');
                if(productBtnIcon){
                    productBtnIcon.parentElement.classList.remove('wishlist-btn--active');
                }
            });
        });
    }

    let onError = function (error) {
        console.log("Error while fetching all Lists", error);
    };

    window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError
    });
}

window.addEventListener('load', handleCartWishlistButtons);
document.addEventListener('swat-wishlist-updated', handleCartWishlistButtons);

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.log('cartUpdateUnsubscriber', event.source);
    setTimeout( function(){
        //wiat for the cartContent to update
        handleCartWishlistButtons();
   }, 1000);
});
